import React, { FunctionComponent } from "react"
import useTranslate from "logic/hooks/use-translate"
import styled from "styled-components"
import { Icon } from "components"
import tw from "twin.macro"

interface ScrollDownProps {
  className?: string
}

const ScrollDownContainer = styled.div`
  ${tw`flex flex-col items-center p-8`}
`

const ScrollDownParagraph = styled.p`
  ${tw`my-4`}
`

const ScrollDownIconContainer = styled.div`
  ${tw`transform rotate-90 hover:cursor-pointer`}
`

const ScrollDownIcon = styled(Icon)`
  ${tw`rounded-full w-16 h-16 border border-gray-100`}
  padding: 25px;
  animation: jello-vertical 4s infinite both;

  @keyframes jello-vertical {
    0% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
    6% {
      -webkit-transform: scale3d(0.75, 1.25, 1);
      transform: scale3d(0.75, 1.25, 1);
    }
    8% {
      -webkit-transform: scale3d(1.25, 0.75, 1);
      transform: scale3d(1.25, 0.75, 1);
    }
    10% {
      -webkit-transform: scale3d(0.85, 1.15, 1);
      transform: scale3d(0.85, 1.15, 1);
    }
    13% {
      -webkit-transform: scale3d(1.05, 0.95, 1);
      transform: scale3d(1.05, 0.95, 1);
    }
    15% {
      -webkit-transform: scale3d(0.95, 1.05, 1);
      transform: scale3d(0.95, 1.05, 1);
    }
    20% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
`

const ScrollDown: FunctionComponent<ScrollDownProps> = ({ className = "" }) => {
  const { SCROLL_DOWN } = useTranslate(["SCROLL_DOWN"])

  return (
    <ScrollDownContainer className={className}>
      <ScrollDownParagraph>{SCROLL_DOWN}</ScrollDownParagraph>
      <button
        onClick={() => {
          document.getElementById("services").scrollIntoView()
        }}
        type="button"
        aria-label="Scroll down"
      >
        <ScrollDownIconContainer>
          <ScrollDownIcon type="arrow" />
        </ScrollDownIconContainer>
      </button>
    </ScrollDownContainer>
  )
}

export default ScrollDown
